import { Input } from "shared/components";
import { Disclosure } from "@headlessui/react";
import { RangeSlider } from "shared/components/RangeSlider";
import { ChevronDown, ChevronUp } from "untitledui-js-base";
import { useEffect, useState } from "react";
import { useRange } from "react-instantsearch-core";

interface RentPriceProps {
  clearSelectedRows: () => void;
}

export const RentPrice = ({ clearSelectedRows }: RentPriceProps) => {
  const {
    start,
    range: { min, max },
    refine
  } = useRange({ attribute: "rent" });
  const [values, setValues] = useState<ReadonlyArray<number>>([
    (min as number) || 0,
    (max as number) || 0
  ]);

  const from = Math.max(
    (min as number) || 0,
    Number.isFinite(start[0] as number)
      ? (start[0] as number)
      : (min as number) || 0
  ) as number;
  const to = Math.min(
    (max as number) || 0,
    Number.isFinite(start[1] as number)
      ? (start[1] as number)
      : (max as number) || 0
  );

  useEffect(() => {
    refine(values as [number, number]);
    clearSelectedRows();
  }, values);

  useEffect(() => {
    setValues([from, to]);
  }, [from, to]);

  return (
    <Disclosure as="div" defaultOpen>
      {({ open }) => (
        <>
          <Disclosure.Button className="w-full">
            <div className="flex w-full justify-between">
              <p className="text-sm font-bold text-content-1000">Rent</p>
              {open ? <ChevronUp /> : <ChevronDown />}
            </div>
          </Disclosure.Button>
          <Disclosure.Panel as="div" className="mb-4 mt-2">
            <div className="mb-4 flex gap-4">
              <Input
                id="startPrice"
                type="money"
                value={values[0]}
                onChange={(e) => setValues([Number(e.target.value), values[1]])}
              />
              <Input
                id="endPrice"
                type="money"
                value={values[1]}
                onChange={(e) => setValues([values[0], Number(e.target.value)])}
              />
            </div>
            <RangeSlider
              minValue={min as number}
              maxValue={max as number}
              values={values}
              setValues={setValues}
            />
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};
